import { fx_plataformaInit } from "../plataforma/PlataformaInit";

document.addEventListener("DOMContentLoaded", () => {
  fx_plataformaInit(false);
});
